import React, { useMemo } from 'react';
import { useMountedState } from 'react-use';
import { Box } from '@mui/material';

import { useDayNightShadingBackground } from 'components/DayNightShading';
import WindForecastGraphContainer from 'components/ForecastGraphWind/components/WindForecastGraphContainer';
import type { ConditionRating } from 'types/conditionRating';
import type { LiveWindPoint } from 'types/liveWind';
import type { SunlightTimes } from 'types/sunlightTimes';
import type { WindData } from 'types/wind';

import styles from './WindForecastContainer.module.scss';

interface Props {
  activeItem: {
    day: number;
    hour: number;
    condition?: ConditionRating;
  };
  liveWind: Array<LiveWindPoint> | null;
  wind: WindData;
  day: number;
  displayOrderIndex: number;
  sunlightTimes: SunlightTimes;
  isLive: boolean;
  isMobile: boolean;
}

const WindForecastContainer: React.FC<Props> = ({
  activeItem,
  liveWind,
  wind,
  day,
  displayOrderIndex,
  sunlightTimes,
  isLive,
  isMobile,
}) => {
  const isMounted = useMountedState();
  const { background } = useDayNightShadingBackground({ sunlightTimes, dayIndex: day });

  const shadingStyle = useMemo(
    () => ({
      background,
      height: '100%',
      width: '100%',
    }),
    [background],
  );

  return (
    <Box
      className={styles.forecastGraphWind}
      style={shadingStyle}
      data-testid={`${isLive && day === 0 ? 'live-' : ''}wind-graph-day-container`}
    >
      {isMounted() && (
        <WindForecastGraphContainer
          activeItem={activeItem}
          day={day}
          displayOrderIndex={displayOrderIndex}
          isLive={isLive}
          wind={wind}
          liveWind={liveWind}
          isMobile={isMobile}
        />
      )}
    </Box>
  );
};

export default WindForecastContainer;
